import {ActionTypes} from '../constants/ActionTypes';

export function getOverview(overview) {
  return {type: ActionTypes.GET_OVERVIEW, overview};
};

export function getOverviewByUser(overview, userID) {
  return {type: ActionTypes.GET_OVERVIEW_BY_USER, overview, userID};
};

export function getOverviewByTrackers(trackers) {
  return {type: ActionTypes.GET_OVERVIEW_BY_TRACKER, trackers};
};


// WEBPACK FOOTER //
// ./src/actions/overview.js